import React, { useContext, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BsPatchCheckFill, BsPeople, BsBoxArrowRight } from "react-icons/bs";
import { FaMoon } from "react-icons/fa";
import { IoSunnyOutline } from "react-icons/io5";
import { FaPowerOff, FaArrowRightFromBracket } from "react-icons/fa6";
import { dropDownMenuUserList } from "./drop-down-menu-user-list";
import { AuthContext } from "../../contexts/AuthContext";
import { WorkspaceContext } from "../../contexts/WorkspaceContext";
import { ThemeContext } from "../../contexts/ThemeContext";
import Person from "../Person";

export default function DropdownMenuUser({ display, setDisplay }) {
  const { theme, setTheme } = useContext(ThemeContext);
  const { user, logout } = useContext(AuthContext);
  const { currentWorkspace, workspaces, selectWorkspace, closeWorkspace, leaveWorkspace } = useContext(WorkspaceContext);
  const navigate = useNavigate();
  const boxDropdownMenuUser = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        boxDropdownMenuUser.current &&
        !boxDropdownMenuUser.current.contains(event.target)
      ) {
        setDisplay(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCloseWorkspace = () => {
    closeWorkspace();
    setDisplay(false);
    navigate("/workspaces", { replace: true });
  };

  return (
    <>
      {user ? (
        <div
          ref={boxDropdownMenuUser}
          className={`dropdown-menu dropdown-menu-end ${
            display
              ? "animate__animated animate__backInUp animate__repeat-1 show affiche-dropdown-menu-user"
              : ""
          }`}
        >
          <div className="dropdown-gap">
            <div className="tyn-media-group">
              <div className="tyn-media tyn-size-lg">
                <Person
                  person={{
                    image: user.userImage,
                    nom: user.nom,
                    prenom: user.prenom,
                    colors: user.color,
                    userId: user.userId,
                  }}
                />
              </div>
              <div className="tyn-media-col">
                <div className="tyn-media-row">
                  <h6 className="name">{user.prenom + " " + user.nom}</h6>
                  <div className="indicator varified">
                    <BsPatchCheckFill />
                  </div>
                </div>
                <div className="tyn-media-row has-dot-sap">
                  <p className="content">{user.poste}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="dropdown-gap">
            <div className="d-flex gap gap-2">
              {theme === "dark" ? <FaMoon /> : <IoSunnyOutline />}
              <div>
                <h6>Thème</h6>
                <ul className="d-flex align-items-center gap gap-3">
                  <li className="inline-flex">
                    <div className="form-check">
                      <input
                        onChange={() => setTheme("dark")}
                        className="form-check-input"
                        type="radio"
                        name="themeMode"
                        id="dark"
                        value="dark"
                      />
                      <label
                        className="form-check-label small"
                        htmlFor="dark"
                        style={{ color: theme === "dark" ? "#fff" : "#000" }}
                      >
                        {" "}
                        Sombre{" "}
                      </label>
                    </div>
                  </li>
                  <li className="inline-flex">
                    <div className="form-check">
                      <input
                        onChange={() => setTheme("light")}
                        className="form-check-input"
                        type="radio"
                        name="themeMode"
                        id="light"
                        value="light"
                      />
                      <label
                        className="form-check-label small"
                        htmlFor="light"
                        style={{ color: theme === "dark" ? "#fff" : "#000" }}
                      >
                        {" "}
                        Clair{" "}
                      </label>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Sélecteur de workspace (toujours visible) */}
          {workspaces.length > 0 && (
            <div className="dropdown-gap border-top pt-2">
              <h6 className="px-3 mb-2 small text-muted">
                <BsPeople className="me-1" />
                Espace de travail
              </h6>
              <ul className="tyn-list-links">
                {workspaces.map((ws) => (
                  <li key={ws._id}>
                    <button
                      className={ws._id === currentWorkspace?._id ? "fw-semibold" : ""}
                      onClick={() => {
                        selectWorkspace(ws);
                        setDisplay(false);
                        navigate("/", { replace: true });
                      }}
                      style={{ fontSize: "0.85rem" }}
                    >
                      <span className={`tyn-bullet ${ws._id === currentWorkspace?._id ? "bg-primary" : ""}`} />
                      {ws.nom}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <ul className="tyn-list-links">
            {/* Fermer l'espace (si on est dans un workspace) */}
            {currentWorkspace && (
              <li>
                <button onClick={handleCloseWorkspace}>
                  <FaArrowRightFromBracket />
                  <span>Fermer l'espace</span>
                </button>
              </li>
            )}

            {/* Liens de navigation (Mon Profil, Changer mot de passe — seulement si workspace) */}
            {currentWorkspace &&
              dropDownMenuUserList.map((elem, idx) =>
                idx === dropDownMenuUserList.length - 1 ? null : (
                  <li key={idx}>
                    <Link to={elem.linkTo} onClick={() => setDisplay(false)}>
                      {elem.icon}
                      <span>{elem.span}</span>
                    </Link>
                  </li>
                )
              )}

            {/* Se déconnecter (toujours visible) */}
            <li>
              <button
                onClick={() => {
                  closeWorkspace();
                  navigate("/");
                  logout();
                }}
              >
                <FaPowerOff />
                <span>Se déconnecter</span>
              </button>
            </li>
          </ul>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
